<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip top>
        <template v-slot:activator="tooltipProps">
          <v-btn
            small
            icon
            color="primary"
            @click="() => copyId(item._id)"

            v-bind="tooltipProps.attrs"
            v-on="tooltipProps.on"
          >
            <v-icon small>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:default>
          Copiar _id
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.blockedQuantity="{ item }">
      <span :class="{ 'error--text': item.blockedQuantity > 0 }">
        {{ formatNumber(item.blockedQuantity || null) }}
      </span>
    </template>

    <template v-slot:item.currency="{ item }">
      {{ item.currency }}
    </template>

    <template v-slot:item.unitaryPrice="{ item }">
      {{ formatMoney(item.unitaryPrice) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatMoney(item.value) }}
      </span>
    </template>

    <template v-slot:item.blockedValue="{ item }">
      <span :class="{ 'error--text': item.blockedValue > 0 }">
        {{ formatMoney(item.blockedValue) }}
      </span>
    </template>

    <template v-slot:item.mtdPerf="{ item }">
      <span :class="{ 'error--text': item.mtdPerf < 0 }">
        {{ formatPerformance(item.mtdPerf) }}
      </span>
    </template>

    <template v-slot:item.ytdPerf="{ item }">
      <span :class="{ 'error--text': item.ytdPerf < 0 }">
        {{ formatPerformance(item.ytdPerf) }}
      </span>
    </template>

    <template v-slot:item.mtd="{ item }">
      <span :class="{ 'error--text': item.mtd < 0 }">
        {{ formatPerformance(item.mtd) }}
      </span>
    </template>

    <template v-slot:item.ytd="{ item }">
      <span :class="{ 'error--text': item.ytd < 0 }">
        {{ formatPerformance(item.ytd) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatMoney,
  formatNumber,
  formatPercentage,
  formatPerformance,
} from '@/utils/format-utils';

import copyToClipboard from '@/utils/copy-to-clipboard';

export default {
  name: 'HoldingSharesTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: 'actions',
        text: 'Ações',
        sortable: false,
        groupable: false,
        width: '48px',
      },

      {
        value: 'ticker',
        text: 'Ativo',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'blockedQuantity',
        text: 'Qtd. Bloq.',
        align: 'end',
      },

      {
        value: 'currency',
        text: 'Moeda',
        align: 'end',
      },

      {
        value: 'unitaryPrice',
        text: 'PU',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor',
        align: 'end',
      },

      {
        value: 'blockedValue',
        text: 'Valor Bloq.',
        align: 'end',
      },

      {
        value: 'mtd',
        text: 'MTD',
        align: 'end',
      },

      {
        value: 'ytd',
        text: 'YTD',
        align: 'end',
      },

      {
        value: 'mtdPerf',
        text: 'Atrib. Perf. Mensal',
        align: 'end',
      },

      {
        value: 'ytdPerf',
        text: 'Atrib. Perf. Anual',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatMoney,
    formatNumber,
    formatPercentage,
    formatPerformance,

    copyId(id) {
      try {
        copyToClipboard(id);

        this.$store.dispatch('notification', {
          text: `_id ${id} copiado com sucesso!`,
          status: true,
        });
      } catch (error) {
        this.$store.dispatch('notification', {
          text: `Não foi possível copiar o _id ${id}`,
          status: true,
          color: 'error',
        });
      }
    },
  },
};
</script>
